var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentColor)?_c('div',{staticClass:"d-inline-block btn",class:_vm.size,style:(`color: ${_vm.currentColor.text}; background-color: ${_vm.currentColor.bg}`),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }